import get from 'lodash.get';
import status from 'src/js/modules/status';
import statusNames from '../constants/status-names';

const getEcommercePackagesStatus = (rootState) =>
  get(status.selectors.getStatus(rootState), statusNames.ECOMMERCE_PACKAGES);

export default getEcommercePackagesStatus;
